import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade",
  id: "verifyModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = {
  key: 0,
  class: "absolute-loader-wrap justify-content-center d-flex align-items-center"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, "Verify Your Mobile Number"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { for: "" }, "Select Country", -1)
const _hoisted_12 = { class: "col-md-8" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { for: "" }, "Enter Phone Number", -1)
const _hoisted_15 = { class: "input-group" }
const _hoisted_16 = { class: "input-group-prepend" }
const _hoisted_17 = { class: "input-group-text" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "text-success" }
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check-circle" }, null, -1)
const _hoisted_22 = { class: "form-group mt-4" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { for: "" }, "Enter your OTP here", -1)
const _hoisted_24 = { class: "input-group" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("span", { class: "input-group-text bg-priamry" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-mobile-alt" })
  ])
], -1)
const _hoisted_26 = { class: "col-lg-7 d-flex align-items-center" }
const _hoisted_27 = { class: "form-group otp-counter" }
const _hoisted_28 = /*#__PURE__*/_createVNode("p", { class: "otp-mini-text" }, " (An OTP Code has been sent to your mobile phone)", -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Didn't receive the OTP? ")
const _hoisted_30 = { class: "form-group mt-3" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-dismiss": "modal"
  }, "Close")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_ErrorList, {
            errors: _ctx.state.data.error.erorList,
            hasError: _ctx.state.data.error.hasError
          }, null, 8, ["errors", "hasError"]),
          (_ctx.state.ui.isPostLoading.sendOtp)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("img", {
                  src: _ctx.state.data.imageBaseUrl
                            ? `${_ctx.state.data.imageBaseUrl}img/loading.gif`
                            : 'img/loading.gif'
                            ,
                  alt: ""
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_6,
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createVNode("select", {
                    id: "country-code-select",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.data.phone.code = $event))
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.countryCodeList, (item, itemIndex) => {
                      return (_openBlock(), _createBlock("option", {
                        value: item.dial_code,
                        key: itemIndex
                      }, _toDisplayString(item.dial_code) + " " + _toDisplayString(item.name), 9, ["value"]))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.state.data.phone.code]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode("div", _hoisted_15, [
                    _createVNode("div", _hoisted_16, [
                      _createVNode("span", _hoisted_17, _toDisplayString(_ctx.state.data.phone.mobileCode), 1)
                    ]),
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: _ctx.state.data.phone.isValid ? 'form-control error-field' : 'form-control',
                      placeholder: "",
                      fdprocessedid: "lpbr9",
                      autocomplete: "off",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.phone.number = $event))
                    }, null, 2), [
                      [_vModelText, _ctx.state.data.phone.number]
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_18, [
              _createVNode("button", {
                class: "btn default-btn",
                disabled: _ctx.state.ui.inputOtp,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.sendOtp && _ctx.sendOtp(...args)))
              }, "Send", 8, ["disabled"])
            ]),
            (_ctx.state.ui.inputOtp)
              ? (_openBlock(), _createBlock("div", _hoisted_19, [
                  _createVNode("p", _hoisted_20, [
                    _hoisted_21,
                    _createTextVNode(" We have sent you an sms with a code to number " + _toDisplayString(_ctx.state.data.phone.mobileCode) + " " + _toDisplayString(_ctx.state.data.phone.number) + ".", 1)
                  ]),
                  _createVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: _ctx.state.data.phone.isOtp ? 'form-control error-field' : 'form-control',
                        placeholder: "verification code",
                        fdprocessedid: "znximg",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.phone.otp = $event)),
                        number: ""
                      }, null, 2), [
                        [_vModelText, _ctx.state.data.phone.otp]
                      ])
                    ]),
                    _createVNode("div", _hoisted_26, [
                      _createVNode("div", _hoisted_27, _toDisplayString(_ctx.state.data.timeCount), 1),
                      _hoisted_28
                    ])
                  ]),
                  _createVNode("p", null, [
                    _hoisted_29,
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      class: "text-decoration-underline",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.sendOtp && _ctx.sendOtp(...args)))
                    }, "Resend")
                  ]),
                  _createVNode("div", _hoisted_30, [
                    _createVNode("button", {
                      class: "btn default-btn",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.verifyMobile && _ctx.verifyMobile(...args)))
                    }, "Verify")
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_31
        ])
      ])
    ])
  ]))
}